// biome-ignore lint/performance/noNamespaceImport: xlsx package exposes utils via namespace
import * as XLSX from "xlsx";
import type { CommunicationVehicle } from "../types";
import {
	formatCommunicationDateTime,
	formatCommunicationEmptyValue,
	formatCommunicationStatus,
} from "./communication-render";
import { stripPlateHyphens } from "./plate.utils";

export function exportCommunicationXlsx(
	items: CommunicationVehicle[],
	filenameSuffix: string
): void {
	if (!items.length) {
		return;
	}

	const rows = items.map((item) => ({
		Grupo: formatCommunicationEmptyValue(item.groupName),
		Placa: stripPlateHyphens(item.plate),
		Modelo: formatCommunicationEmptyValue(item.model),
		Status: formatCommunicationStatus(item.status),
		"Última comunicação": formatCommunicationDateTime(item.lastPosition),
	}));

	const worksheet = XLSX.utils.json_to_sheet(rows);
	const workbook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(workbook, worksheet, "Comunicação");

	const dateStamp = new Date().toISOString().slice(0, 10);
	const safeSuffix = filenameSuffix
		.toLowerCase()
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/^-|-$/g, "");

	XLSX.writeFile(
		workbook,
		`comunicacao-${safeSuffix || "frota"}-${dateStamp}.xlsx`
	);
}
